import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Core2Config, BasicApiResponseModel, ApiVisa } from './../../shared';
import { GameApiCheckoutModel, GameApiContainerModel, GameApiInquiryModel } from './game-api-response.model';

@Injectable()
export class GameApiIntegrationService {

  protected readonly endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.UNIPIN_PREFIX + 'gamer/';

  constructor(protected readonly http: HttpClient) {}

  public getRequiredField(gameType: string, country_code: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<any> { 
    return this.http.post(`${ api_domain_url + this.endpoint_path }required-field/${ gameType }`, { country_code }, { headers: new HttpHeaders({ authorization: jwt_secret, tenantCode }) }); 
  }

  public inquiry(gameType: string, data: GameApiInquiryModel, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<BasicApiResponseModel<GameApiContainerModel>> {
    return this.http.post<BasicApiResponseModel<GameApiContainerModel>>(`${ api_domain_url + this.endpoint_path }inquiry/${ gameType }`, data, { headers: new HttpHeaders({ authorization: jwt_secret, tenantCode }) });
  }

  public checkout(gameType: string, data: GameApiCheckoutModel, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<BasicApiResponseModel<GameApiContainerModel>> {
    return this.http.post<BasicApiResponseModel<GameApiContainerModel>>(`${ api_domain_url + this.endpoint_path }checkout/${ gameType }`, data, { headers: new HttpHeaders({ authorization: jwt_secret, tenantCode }) });
  }
}
